import {getSessionsConfig } from '../../config/get-sessions-config';

const config = getSessionsConfig()

export const useConfig = () => {
    return config;
}
